import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Tooltip
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { FlagProjectsReportSummary } from "../api/models/ReportModels";
import routes from "../../../Common/consts/routes";

interface CostCenterValidationGridProps {
    reports: FlagProjectsReportSummary[];
}

const CostCenterValidationGrid = ({ reports }: CostCenterValidationGridProps): JSX.Element => {
    const navigate = useNavigate();

    const handleViewDetails = (reportId: number) => {
        navigate(routes.admin.reportDetail.replace(':id', reportId.toString()));
    };

    const parseReportSummary = (dataJson: string) => {
        try {
            const data = JSON.parse(dataJson);
            return {
                locked: data.LockedCount || 0,
                advanced: data.AdvancedCount || 0,
                newlyFlagged: data.NewlyFlaggedCount || 0,
                unflagged: data.UnflaggedCount || 0
            };
        } catch {
            return { locked: 0, advanced: 0, newlyFlagged: 0, unflagged: 0 };
        }
    };

    return (
        <Box pl="80px" pt="24px" height="100%">
            <TableContainer component={Paper} sx={{ width: "92%", pb: 0, mb: "70px", mt: "10px" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: "20%" }}>
                                <b>Date</b>
                            </TableCell>
                            <TableCell sx={{ width: "15%" }}>
                                <b>Locked</b>
                            </TableCell>
                            <TableCell sx={{ width: "15%" }}>
                                <b>Advanced</b>
                            </TableCell>
                            <TableCell sx={{ width: "15%" }}>
                                <b>Newly Flagged</b>
                            </TableCell>
                            <TableCell sx={{ width: "15%" }}>
                                <b>Unflagged</b>
                            </TableCell>
                            <TableCell sx={{ width: "10%" }}>
                                <b>Actions</b>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports.map((report) => {
                            const summary = parseReportSummary(report.dataJson);
                            return (
                                <TableRow key={report.id} hover>
                                    <TableCell>
                                        {new Date(report.completedDate).toLocaleString()}
                                    </TableCell>
                                    <TableCell>{summary.locked}</TableCell>
                                    <TableCell>{summary.advanced}</TableCell>
                                    <TableCell>{summary.newlyFlagged}</TableCell>
                                    <TableCell>{summary.unflagged}</TableCell>
                                    <TableCell>
                                        <Tooltip title="View Details">
                                            <IconButton
                                                onClick={() => handleViewDetails(report.id)}
                                                size="small"
                                            >
                                                <Visibility />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default CostCenterValidationGrid;
